// PDF v2.4 leaves these response rows unnumbered. Do not invent another level.
const unnumberedParts = new Set(['1b', '1c', '3', '11b', '13a', '13b', '13c', '13d', '33', '54a', '73c', '89', '96']);

export function trafficPartPrefix(question, index) {
  return unnumberedParts.has(String(question.numberLabel)) ? '' : `${String.fromCharCode(97 + index)}. `;
}

export function trafficMatchingPrefix(question, index) {
  return String(question.numberLabel) === '110' ? `${index + 1}. ` : '';
}
